<template>
  <v-dialog v-model="show_dialog" width="500" persistent>
    <v-card>
      <v-card-title class="secondary white--text">
        Send Notification
        <v-spacer></v-spacer>
        <v-btn icon dark @click="show_dialog=false">
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary"></v-progress-linear>
      </v-card-title>
      <v-container>
        <v-row align="center">
          <v-col cols="12" v-if="user">
            <v-text-field outlined hide-details label="User" :value="user.name" readonly></v-text-field>
          </v-col>
          <v-col cols="12" v-if="portal">
            <v-text-field
              outlined
              hide-details
              label="Regarding portal"
              :value="portal.title"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-if="contest">
            <v-text-field outlined hide-details label="For Contest" :value="contest.title" readonly></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              label="Website Notification"
              hide-details
              clearable
              :items="templates"
              item-text="name"
              item-value="id"
              v-model="selected_template"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              label="Email Notification"
              hide-details
              clearable
              :items="email_templates"
              item-text="name"
              item-value="id"
              v-model="selected_email_template"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="grey lighten-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="sendNotification" :loading="loading">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "AdminSendNotification",
  data: () => ({
    show_dialog: false,
    user: null,
    portal: null,
    contest: null,
    templates: [],
    email_templates: [],
    loading: false,
    selected_template: null,
    selected_email_template: null
  }),
  created() {
    this.$eventBus.$on("send_notification", this.openNotifications);
  },
  methods: {
    async load() {
      this.loading = true;
      this.templates = await this.$api(`/admin/notification-templates`);
      this.email_templates = await this.$api(
        `/admin/email-notification-templates`
      );
      this.loading = false;
    },
    async sendNotification() {
      if (!this.user) {
        return alert("Missing user");
      }
      if (!this.selected_template && !this.selected_email_template) {
        return alert("No template selected");
      }
      this.loading = true;
      try {
        if (this.selected_template) {
          await this.sendTemplate(this.user, this.selected_template);
        }
        if (this.selected_email_template) {
          await this.sendEmailTemplate(this.user, this.selected_email_template);
        }
        alert("Sent notifications.");
        this.show_dialog = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async sendTemplate(user, template) {
      await this.$api.post(`/admin/notification-templates/send`, {
        user_id: user.id,
        template_id: template,
        portal_id: this.portal ? this.portal.id : null
      });
    },
    async sendEmailTemplate(user, template) {
      await this.$api.post(`/admin/email-notification-templates/send`, {
        user_id: user.id,
        template_id: template,
        portal_id: this.portal ? this.portal.id : null
      });
    },
    async openNotifications(options) {
      console.log("called", "openNotifications");
      this.show_dialog = true;
      this.user = options.user;
      this.portal = options.portal;
      this.load();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
